import React from 'react';
import { element } from 'prop-types';
import { MenuWrapper } from '../../menu';
import { ButtonIcon } from '../../icon';
import TableCell from './cell';

const wrappedElement = <ButtonIcon>more_vert</ButtonIcon>;

const ActionCell = ({ children, ...props }) => (
  <TableCell actions {...props} >
    {children && (
      <MenuWrapper
        floating
        wrappedElement={wrappedElement}
      >
        {React.Children.only(children)}
      </MenuWrapper>
    )}
  </TableCell>
);

ActionCell.propTypes = {
  children: element,
};

ActionCell.defaultProps = {
  children: undefined,
};

export default ActionCell;
